var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "stat-text pt-0 pb-0 mt-n2", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("CALLSIGN")
              ]),
              _vm._v(" "),
              _c(
                "cc-short-string-editor",
                {
                  on: {
                    set: function($event) {
                      _vm.pilot.Callsign = $event
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.pilot.Callsign) + "\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("NAME")
              ]),
              _vm._v(" "),
              _c(
                "cc-short-string-editor",
                {
                  on: {
                    set: function($event) {
                      _vm.pilot.Name = $event
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.pilot.Name))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("BACKGROUND")
              ]),
              _vm._v(" "),
              _c(
                "cc-short-string-editor",
                {
                  staticClass: "d-inline",
                  on: {
                    set: function($event) {
                      _vm.pilot.Background = $event
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.pilot.Background) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                [
                  _c("cc-background-selector", {
                    staticClass: "d-inline fadeSelect ml-n1",
                    attrs: { pilot: _vm.pilot, small: "" },
                    on: {
                      select: function($event) {
                        _vm.pilot.Background = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "stat-text pt-0 mt-n3", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("PLAYER")
              ]),
              _vm._v(" "),
              _c(
                "cc-short-string-editor",
                {
                  on: {
                    set: function($event) {
                      _vm.pilot.PlayerName = $event
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pilot.PlayerName || "---") +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("OMNINET UPLINK ID")
              ]),
              _vm._v(" "),
              _vm.pilot.CloudID
                ? _c("span", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.pilot.CloudID) + "\n      "
                    )
                  ])
                : _c("span", { staticClass: "stat-text error--text" }, [
                    _vm._v("\n        // NOT SYNCED //\n      ")
                  ]),
              _vm._v(" "),
              !_vm.syncing
                ? _c(
                    "cc-tooltip",
                    {
                      attrs: {
                        inline: "",
                        title:
                          !_vm.pilot.CloudID || _vm.pilot.IsUserOwned
                            ? "Save to Cloud"
                            : "Update from Cloud",
                        content: "Last Sync at:<br>" + _vm.pilot.LastCloudUpdate
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "fadeSelect",
                          attrs: { small: "" },
                          on: {
                            click: function($event) {
                              return _vm.sync()
                            }
                          }
                        },
                        [_vm._v("mdi-cloud-sync")]
                      )
                    ],
                    1
                  )
                : _c(
                    "cc-tooltip",
                    {
                      attrs: { simple: "", inline: "", content: "Syncing..." }
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "20",
                          width: "2",
                          color: "secondary"
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            [
              _c("div", { staticClass: "overline mb-n3 subtle--text" }, [
                _vm._v("STATUS")
              ]),
              _vm._v(" "),
              _c(
                "span",
                { class: "stat-text " + _vm.statusColor() + "--text" },
                [_vm._v(_vm._s(_vm.pilot.Status))]
              ),
              _vm._v(" "),
              _c("cc-combo-select", {
                attrs: { items: _vm.pilotStatuses },
                on: {
                  set: function($event) {
                    _vm.pilot.Status = $event
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("cloud-manager", {
        ref: "cloud",
        attrs: { pilot: _vm.pilot },
        on: {
          "end-sync": function($event) {
            _vm.syncing = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }